import PopOver from "../../../../components/View/PopOver";
import { Button, Stack } from "@mantine/core";
import { IconChevronDown, IconHandFinger } from "@tabler/icons-react";
import NurturingSettings from "./nurturing/NurturingSettings";
import CaptchaContacts from "./captchas/CaptchaContacts";
import ScoreSettings from "./score/ScoreSettings";
import { useLanguage } from "../../../../stores/LanguageStore";
import { useProfileStore } from "../../../../stores/UserStore";
import { useParams } from "react-router-dom";
import LeadMarkAuto from "../controller/LeadMarkAuto";
import Nurturings from "./nurturings/Nurturings";
import NotificationSettings from "./notification/NotificationSettings";

const LeadActions = ({ disabled }) => {
  const lang = useLanguage((s) => s.language);
  const { userId } = useParams();
  const profile = useProfileStore((s) => s.profile);

  const differentPrm = userId ? profile?.id !== parseInt(userId) : false;

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          ref={ref}
          leftSection={<IconHandFinger size={18} />}
          rightSection={<IconChevronDown size={16} />}
          radius={"md"}
          color="primary"
          onClick={handleOpen}
          variant="light"
          size="md"
          disabled={differentPrm}
        >
          {lang.leads.lead_actions}
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack p={4}>
          <Nurturings disabled={disabled} />
          {/* <NurturingSettings disabled={disabled} /> */}

          <ScoreSettings disabled={disabled} />

          <CaptchaContacts disabled={disabled} />

          <NotificationSettings disabled={disabled} />

          <LeadMarkAuto />

          {/* <LeadAnswerPositiveNotif />

          <LeadAnswerNegativeNotif />

          <LeadAnswerNeutralNotif /> */}
        </Stack>
      )}
    />
  );
};

export default LeadActions;
